import { motion } from "framer-motion";
import { experience } from "../data/portfolio";
import { SectionHeader } from "./SectionHeader";

export const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="section-experience"
      className="relative py-24 md:py-32 px-5 sm:px-8"
    >
      <div className="max-w-6xl mx-auto">
        <SectionHeader
          testId="experience-header"
          index="01 // experience"
          title="Where I've worked"
          sub="Internships across AI/ML, geospatial ML and full-stack web — shipping models, reports and production interfaces."
        />

        <ol className="relative border-l border-white/10 ml-2 md:ml-4">
          {experience.map((job, i) => (
            <motion.li
              key={job.company}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="timeline-item pl-6 md:pl-10 pb-14 last:pb-0"
              data-testid={`experience-item-${i}`}
            >
              <span className="timeline-node absolute -left-[7px] mt-2 w-3.5 h-3.5 rounded-full bg-purple-500 border-2 border-[#06030f]" />

              <div className="flex flex-col md:flex-row md:items-baseline md:justify-between gap-1 md:gap-6">
                <div>
                  <h3
                    className="text-xl md:text-2xl font-semibold text-white"
                    data-testid={`experience-role-${i}`}
                  >
                    {job.role}
                    <span className="text-purple-400"> @ </span>
                    <span className="text-purple-200">{job.company}</span>
                  </h3>
                </div>
                <div className="font-mono text-xs tracking-wider text-white/50 whitespace-nowrap">
                  {job.dates} · {job.location}
                </div>
              </div>

              <ul className="mt-4 space-y-2 text-white/70 leading-relaxed max-w-3xl">
                {job.bullets.map((b, bi) => (
                  <li key={bi} className="flex gap-3">
                    <span className="mt-2 h-1 w-1 rounded-full bg-purple-400 flex-shrink-0" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-4 flex flex-wrap gap-2">
                {job.stack.map((t) => (
                  <span
                    key={t}
                    className="font-mono text-[11px] px-2 py-1 rounded border border-white/10 text-white/70 bg-white/[0.02]"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
};
